import { Component, Inject, Input, OnInit, Output, EventEmitter, OnDestroy, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { CarouselIncidentRecordComponent } from '../carousel-incident-record/carousel-incident-record.component';
import { Router } from '@angular/router';
import { RejectIncidentsComponent } from '../reject-incidents/reject-incidents.component';
import { HttpErrorResponse } from '@angular/common/http';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { CarrouselData, CarrouselDetailData } from 'src/app/domain/carrousel.model';
import { rejectIncidentData } from 'src/app/domain/rejectIncident.model';
import { closeModalEventData } from 'src/app/domain/incidentRecord.model';
import { ControlTowerModalService } from 'src/app/services/shared/control-tower-modal.service';
import { PropertiesTowers } from 'src/app/services/dashboards/propertiesTower.service';
import { Subscription } from 'rxjs';
import { MatSnackBar as MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { LoginService } from 'src/app/services/security/login.service';
import { DomSanitizer } from '@angular/platform-browser';
import { EventsService } from 'src/app/services/dashboards/events.service';
import { RefreshDataDto } from 'src/app/interfaces/Dtos/refresh-data.dto';
import { GridServiceService } from 'src/app/services/shared/grid-service.service';
import { max } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { BlobStorageUrlService } from 'src/app/services/shared/blob-storage-url.service';
import { Embed } from 'powerbi-client';
import { ControltowerService } from 'src/app/services/dashboards/controltower.service';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
  selector: 'neoris-incident-record',
  templateUrl: './incident-record.component.html',
  styleUrls: ['./incident-record.component.css'],
  providers: [DatePipe]
})
export class IncidentRecordComponent implements OnInit, AfterViewInit, OnDestroy {

  public showCarrousel: boolean = false
  public readonly FORM_EMBED: string = 'embed'
  public readonly FORM_MODAL: string = 'modal'
  public urlImage: string = ''
  private incidentData: any;
  public disableButtons: boolean = false;

  public mode: string = ''
  arraySites: any[] = []
  arrayStatus: any[] = []
  ud: any = {}
  form = this.formBuilder.group({
    Event: [{ value: '', disabled: true }],
    Status: [{ value: '', disabled: true }],
    Date: [{ value: '', disabled: true }],
    Site: [{ value: '', disabled: true }],
    Location: [{ value: '', disabled: true }],
    Type: [{ value: '', disabled: true }],
    ActionsTaken: ['', [Validators.maxLength(1000)]],
    Responsible: ['', [Validators.maxLength(50)]],
    SafetyItems: [''],
    DueDate: [''],
    EmbeddingPromptResponse: [{ value: '', disabled: true }],
  });

  @Input()
  set Mode(mode: string) {
    this.mode = mode

    switch (this.mode) {
      case this.FORM_MODAL:
        break;
      case this.FORM_EMBED:
        break;
    }

    this.form.updateValueAndValidity()
  }

  @Output() closeModalEvent = new EventEmitter<closeModalEventData>();

  @Input()
  set Data(data: any) {


    this.showCarrousel = false;

    if (data !== undefined) {
      this.incidentData = data
      console.log("safetyItems", this.incidentData.safetyItems)
      this.DisableButtons()
      this.SetFormData(data, 'load')
      this.ShowImages(data)
    }
  }

  private canCloseForm: boolean = false;

  public EmbeddingPromptResponseVisible: boolean = true

  private SetFormData(data: any, from: string) {

    let date_value = this.datePipe.transform(data.occurred, 'MM/dd/yyyy HH:mm')

    console.log("SetFormData", data.embbedingPromptResponse)
    this.form.reset({
      Event: data.eventDescription,
      Date: date_value,
      Site: data.site,
      Location: data.incidentArea,
      Type: data.incidentType,
      ActionsTaken: data.actionTaken,
      Responsible: data.responsible,
      DueDate: data.dueDate,
      SafetyItems: data.safetyItems,
      Status: data.incidentStatus,
      EmbeddingPromptResponse: data.embbedingPromptResponse,
    })

    //Show/Hide EmbeddingPromptResponse when the value is empty
    if (data.embbedingPromptResponse == null || data.embbedingPromptResponse == '') {
      this.EmbeddingPromptResponseVisible = false
    } else {
      this.EmbeddingPromptResponseVisible = true
    }

    console.log("form", this.form)

    switch (from) {
      case "load":
        this.canCloseForm = false;
        break;
      case "event_grid":
        this.canCloseForm = false;
        break;
    }

  }

  private DisableButtons() {
    if (this.incidentData.incidentStatusId == 10002) {
      this.disableButtons = true
    } else {
      this.disableButtons = false
    }
  }

  public image: any
  public isImage: boolean = false
  public eventImages: any[] = []

  private async ShowImages(data: any) {

    this.image = "/assets/images/blank.svg"
    this.isImage = true
    // this.showCarrousel = true

    var blobStorageUrl = await this.LocationService.GetBlobStorageUrlApi();
    environment.authClientId = blobStorageUrl.authClientId
    environment.urlAuth = blobStorageUrl.authUrl
    environment.urlStorageApi = blobStorageUrl.blobStorageUrl
    // environment.authenticateStorageApi = blobStorageUrl.requireAuthenticate

    var result = await this.GetAuthToken()

    if(result == false){
      this.SetNoImageOnIncidentRecord()
    }

    let eventIds = {
      EventIds: [data.eventId]
    }

    await this.GetEventsFileNames(eventIds, this.access_token)

    if (this.fileNames.length > 0) {
      var eventFiles = this.fileNames[0];

      if (eventFiles.fileUrls.length > 0) {
        var firstImage = eventFiles.fileUrls[0];

        // eventFiles.shift();
        
        this.eventImages = eventFiles.fileUrls;

        this.eventsService.StreamingBlob(firstImage, this.access_token).subscribe({
          next: (blob: Blob) => {
            const url = URL.createObjectURL(blob);
            this.isImage = this.getFileType(firstImage) === 'image';
            this.image = url//this.sanitizer.bypassSecurityTrustUrl(url);
            this.showCarrousel = true
          },
          error: () => {
            this.SetNoImageOnIncidentRecord() 
          }
        })

      }else{
        this.SetNoImageOnIncidentRecord() 
      }
    }else{
      this.SetNoImageOnIncidentRecord() 
    }
  }


  getFileType(file: string): 'image' | 'video' | 'unknown' {
    const extension = file.split('.').pop()?.toLowerCase();

    if (!extension) return 'unknown';

    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
    const videoExtensions = ['mp4', 'mov', 'avi', 'wmv', 'mkv', 'webm'];

    if (imageExtensions.includes(extension)) return 'image';
    if (videoExtensions.includes(extension)) return 'video';

    return 'unknown';
  }




  private refreshNoImagedata() {
    if (this.imageData.length > 0) {
      var firtImage = this.imageData[0]
      if (firtImage.imageData !== null) {
        // this.isImage = firtImage.mediaType == 'image'
        // let objectURL = `data:${firtImage.mediaType}/${firtImage.extension};base64,` + firtImage.imageData;
        // this.image = this.sanitizer.bypassSecurityTrustUrl(objectURL);
        // this.showCarrousel = true

      } else {
        this.SetNoImageOnIncidentRecord()
      }
    } else {
      this.SetNoImageOnIncidentRecord()
    }
  }


  private SetNoImageOnIncidentRecord() {

    this.isImage = true
    if (this.lang == 'en') {
      this.image = '/assets/images/no_image.svg'
    } else {
      this.image = '/assets/images/sin_imagen.svg'
    }

    // this.image = undefined
    // this.showCarrousel = false
  }


  private clickBtnFormIncidentSubscription: Subscription
  private emitMoveRowDataSubscription: Subscription

  private lang: string = ""
  private onLanChange: Subscription

  constructor(
    private eventsService: EventsService,
    private sanitizer: DomSanitizer,
    public dialog: MatDialog,
    private breakpointObserver: BreakpointObserver,
    private formBuilder: UntypedFormBuilder,
    private datePipe: DatePipe,
    private route: Router,
    private translate: TranslateService,
    private controlTowerModalService: ControlTowerModalService,
    private controltowerservice: ControltowerService,
    private propertiesTowers: PropertiesTowers,
    private _snackBar: MatSnackBar,
    private LocationService: BlobStorageUrlService,
    private gridService: GridServiceService,
    private securityService: LoginService) {

    this.lang = translate.currentLang == null ? 'en' : translate.currentLang

    this.onLanChange = this.translate.onLangChange.subscribe(s => {
      this.lang = s.lang
      this.refreshNoImagedata()
    })
  }

  async ngOnInit(): Promise<void> {

    const userName = JSON.parse(localStorage.getItem('ud'))[1].value
    const guid = JSON.parse(localStorage.getItem('guidSession'))
    const response = await this.securityService.login(userName, guid).toPromise()

    this.ud = JSON.parse(localStorage.getItem('ud'))
    let successSites = await this.getSites()
    let successStatus = await this.getGenericAtrributeValue('en')

    if (this.mode == this.FORM_EMBED) {
      this.clickBtnFormIncidentSubscription = this.propertiesTowers.clickBtnFormIncident.subscribe(s => {
        if (s > 0) {
          this.ClicFromIncidentForm(s)
        }
      })
    }

    this.emitMoveRowDataSubscription = this.gridService.emitMoveRowDataObservable.subscribe((data) => {
      this.showCarrousel = false;
      this.image = undefined
      if (data !== undefined) {
        this.incidentData = data
        this.DisableButtons()
        this.SetFormData(data, 'event_grid')
        this.ShowImages(data)
      }

    });
  }

  ngAfterViewInit() {

  }

  preventScrollOnFocus(element: HTMLElement) {
    element.addEventListener('focusin', (event) => {
      const target = event.target as HTMLElement;
      if (target) {
        const scrollTop = element.scrollTop;
        setTimeout(() => {
          element.scrollTop = scrollTop;
        }, 0);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.clickBtnFormIncidentSubscription !== undefined) {
      this.clickBtnFormIncidentSubscription.unsubscribe()
    }

    this.emitMoveRowDataSubscription.unsubscribe()

    this.onLanChange.unsubscribe()
  }

  private ClicFromIncidentForm(s: any) {

    const data = {
      Event: this.form.get('Event').value,
      Status: this.form.get('Status').value,
      Date: this.form.get('Date').value,
      Site: this.form.get('Site').value,
      Location: this.form.get('Location').value,
      Type: this.form.get('Type').value,
      ActionsTaken: this.form.get('ActionsTaken').value,
      Responsible: this.form.get('Responsible').value,
      DueDate: this.form.get('DueDate').value,
    }

    this.propertiesTowers.sendIncidentRecordData(data)
  }

  public openCarousel() {


     const isSmall = this.breakpointObserver.isMatched('(max-width: 426px)');


    let carrouselModel: CarrouselData = {
      images: this.eventImages
    }

    const dialogConfig = {
      restoreFocus: false,
      data: carrouselModel,
       ...(isSmall
      ? {
        maxWidth: '100vw',
          maxHeight: '100vh'
      } // No tamaños fijos en pantallas pequeñas
      : {
          minWidth: '900px',
          minHeight: '660px',
          maxWidth: '900px',
          maxHeight: '660px'
        })
    };


    // dialogConfig['width'] = '100%';
    // dialogConfig['maxWidth'] = '100%';
    // dialogConfig['height'] = '100%';
    // dialogConfig['maxHeight'] = '100%';
    // if (window.innerWidth <= 425) {
    // dialogConfig['panelClass'] = 'full-screen-dialog';
    // }

    this.dialog.open(CarouselIncidentRecordComponent, dialogConfig);
  }

  goIncidentForm() {

    this.form.updateValueAndValidity();
    const isFormValid: boolean = this.form.valid;
    if (isFormValid) {

      this.route.navigate(['/incident-health-safety-control-tower'])
    } else {

    }
  }

  public showRejectIncident() {

    const incidentModel: rejectIncidentData = {
      eventId: this.incidentData.eventId
    }

    let dialog = this.dialog.open(RejectIncidentsComponent,
      {
        restoreFocus: false,
        width: '600px',
        data: incidentModel
      });

    dialog.afterClosed().subscribe((result) => {

      if (result == true) {
        this.incidentData.incidentStatusId = 10002
        this.incidentData.incidentStatus = 'Rejected'

        this.DisableButtons()
        this.gridService.moveRow('down')

      }
    })

  }

  private async getSites(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.getSites().subscribe(
        {
          next: (sites: any = {}) => {
            this.arraySites = sites.sites
            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }

  private async getGenericAtrributeValue(localCode: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.getAttributeValue(localCode).subscribe(
        {
          next: (attribute: any = {}) => {
            const STATUS_ATRIBUTE = attribute.attributeTypes.find(f => f.id == 43)
            if (STATUS_ATRIBUTE !== undefined) {
              this.arrayStatus = STATUS_ATRIBUTE.attributeValues
            }


            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }

  public closeModal() {
    const closeModalEventData: closeModalEventData = {
      openModal: false
    }

    this.closeModalEvent.emit(closeModalEventData)
  }

  public continueButton() {
    let s = 0
    this.ClicFromIncidentForm(s)
    this.route.navigate(['/incident-health-safety-control-tower'])
  }

  public acceptIncident() {
    let dueDate: string = this.form.get('DueDate').value

    if (dueDate == '') {
      dueDate = undefined
    }

    let incidentFormData = {
      eventId: this.incidentData.eventId,
      categoryId: this.incidentData.categoryId,
      monitoringAdvisor: this.ud[0].value,
      siteId: this.incidentData.siteId,
      typeOfStaffId: this.incidentData.typeOfStaffId,
      descripcion: this.incidentData.descripcion,
      personName: this.incidentData.personName,
      positionId: this.incidentData.positionId,
      rootCauseId: this.incidentData.rootCauseId,
      consequencesSystemId: this.incidentData.consequencesSystemId,
      headOfUN: this.incidentData.headOfUN,
      incidentStatusId: 10001,
      employeeNumber: this.incidentData.employeeNumber,
      registrationDate: this.incidentData.registrationDate,
      actionsTaken: this.form.get('ActionsTaken').value,
      responsible: this.form.get('Responsible').value,
      dueDate: dueDate,
    }

    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.SaveFormIncident(incidentFormData).subscribe(
        {
          next: (attribute: any = {}) => {

            if (this.canCloseForm == true) {
              this.closeModal()
            }


            var refreshData: RefreshDataDto = {
              operation: 'accept-incident',
              object: incidentFormData
            }

            this.controlTowerModalService.refresh(refreshData)

            
            this.gridService.moveRow('down')


            resolve(true);
          }, error: (error: HttpErrorResponse) => {


            const error_message = this.translate.instant('SAVE_INCIDENT_ERROR_MESSAGE')
            this.openSnackBar(error_message, 'ERROR')

            resolve(false);
          }
        }
      )
    });
  }

  openSnackBar(message: string, action: string) {
    if (action == 'OK') {
      this._snackBar.open(message, action, {
        duration: 5000,
        panelClass: ['blue-snackbar']
      });
    }
    else {
      this._snackBar.open(message, action, {
        duration: 5000,
        panelClass: ['blue-snackbar-false']
      });
    }
  }

  private imageData: any

  private access_token = "";

  private async GetAuthToken(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.getAuthIndustrialToken('storage_account', environment.authClientId).subscribe(
        {
          next: (data: any) => {

            this.access_token = data.access_token

            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }


  private fileNames: any[] = [];


  private async GetEventsFileNames(eventsIds: any, access_token: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.eventsService.GetEventsFileNames(eventsIds, access_token).subscribe(
        {
          next: (fileNames: any) => {

            this.fileNames = fileNames

            resolve(true);
          }, error: (error: HttpErrorResponse) => {

            this.fileNames = []

            resolve(false);
          }
        }
      )
    });
  }




  private async GetEventImages(EventId: number, access_token: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.eventsService.GetEventImages(EventId, access_token).subscribe(
        {
          next: (imageData: any) => {

            this.imageData = imageData

            resolve(true);
          }, error: (error: HttpErrorResponse) => {

            this.imageData = []

            resolve(false);
          }
        }
      )
    });
  }

  public moveLeft() {
    this.gridService.moveRow('up')
  }

  public moveRight() {
    this.gridService.moveRow('down')
  }

}


